<template>
  <div v-loading="loadingAll">
      <el-card class="cardHeight">
          <div style="display:flex"><div class="block"></div>
           <span style="margin-left:4px">绑定</span></div>
           <el-form style="margin-top:16px" label-width="112px">
              <el-form-item required label="绑定">
           <span @click="showDialogBtn" style="color:#ff6000;cursor:pointer">选择菜品分类</span>
              <div>
                                <el-tag
            class="mr5"
  v-for="(tag,index) in  selectList"
  :key="tag.productCode"
  closable
   @close="delSelect(index)"
  type="info">
  {{tag.categoryName}}
</el-tag>
              </div>
              </el-form-item>
             
     

           </el-form>
           <div class="foot">
              <el-button 
              class="cancel" @click="()=>{$router.go(-1)}">取消</el-button>
              <el-button @click="save" class="saveBtn">保存</el-button>
           </div>
           <CategoryDialog :categorySelect="selectList" :categoryType="type"
         @categorySumbit="dialogHidden"   :categoryDialogVisible="showDialog" ></CategoryDialog>
      </el-card>
  </div>
</template>
<script>
import CategoryDialog from '../merchantDiscountCreate/components/CategoryDialog.vue'
  export default {
      components:{
          CategoryDialog
      },
      data(){
          return{
            loadingAll:true,
            type:'',
            tableAreaCode:'',
            showDialog:false,
            selectList:[],
            tableData:[]
          }
      },
      created(){
        this.tableAreaCode=this.$route.query.tableAreaCode
        this.queryOne()
      },
      methods:{
      async  queryOne(){
        this.loadingAll=true
 let res=await this.$http.post('merchantAreaCategory/queryList',{merchantCode:localStorage.getItem('merchantCode'),tableAreaCode:this.$route.query.tableAreaCode})
   console.log(res)
        this.loadingAll=false
        this.selectList=res.data.data
   },
        showDialogBtn(){
            this.showDialog=true
        },
      async  save(){
            let data={}
            data.merchantCode=localStorage.getItem('merchantCode')
            data.tableAreaCode=this.tableAreaCode
            let arr=[]
            this.selectList.forEach(item=>{
            arr.push({categoryCode:item.categoryCode,categoryName:item.categoryName})
            })
            data.categoryList=arr
            console.log(data)
  let res=await this.$http.post('merchantAreaClass/addCategoryList',data)
  console.log(res)
  if(res.data.code==200){
          this.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
        setTimeout(()=>{
            this.$router.push('/merchantAreaClass')
        },500)
  }else{
    this.$message.error(res.data.message)
  }
        },
        dialogHidden(list){
            console.log(list)
            this.showDialog=false
            this.selectList=list
        },
        delSelect(index){
            this.selectList.splice(index,1)
        }
      }
  }
</script>

<style lang="scss" scoped>
/deep/ .cardHeight{
  height: calc(100vh - 76px);
  position: relative;
}
.foot{
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid #EAEAEA;
  padding: 14px 46px;
  justify-content: right;
  .saveBtn{
      background-color: #FFBD00;
      border-color: #FFBD00;
  }
}
.flex{
  display: flex;
  align-items: center;
}
.saveBtn:hover{
  color: #606266;
}
.block{
  display:block;
  width: 4px;
  height: 20px;
  background-color: #f59a23;
  border-radius: 4px;
}
/deep/ .el-form-item__label::after{
  content:":";
  padding-left: 2px;;
  
}
/deep/ .el-form>.el-form-item{
  margin-bottom: 20px;
}
.cancel{
  background-color: #fff;
}
/deep/ .mr5{
    margin-right: 5px;
}
</style>